/**
 * Re-initialize Yotpo widgets after dynamic HTML injection (e.g. product recommendations).
 * @see https://support.yotpo.com/docs/loading-yotpo-with-ajax
 */
window.refreshYotpoWidgets = function (maxAttempts, intervalMs) {
  maxAttempts = maxAttempts || 1;
  intervalMs = intervalMs || 300;

  function tryInit() {
    try {
      if (
        window.yotpoWidgetsContainer &&
        typeof window.yotpoWidgetsContainer.initWidgets === "function"
      ) {
        window.yotpoWidgetsContainer.initWidgets();
        return true;
      }
      if (window.yotpo && typeof window.yotpo.initWidgets === "function") {
        window.yotpo.initWidgets();
        return true;
      }
    } catch (e) {
      console.warn("[Yotpo] initWidgets failed", e);
    }
    return false;
  }

  function attempt(remaining) {
    if (tryInit()) return;
    if (remaining > 0) {
      setTimeout(function () {
        attempt(remaining - 1);
      }, intervalMs);
    }
  }

  attempt(maxAttempts - 1);
};

document.addEventListener("shopify:section:load", function () {
  window.refreshYotpoWidgets(5, 300);
});
